module.exports = __webpack_public_path__ + "static/media/info.403540a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/info.jpg
// module id = 2347
// module chunks = 0